import { PropertyIdFilterOption } from "../components/PropertyIdFilter";
import { IPropertyAnalyticsItem } from "../types/ownerDashboard.types";

export function resolvePropertyAnalyticsLabel(item: IPropertyAnalyticsItem): string {
  const address = item.property_address?.trim();
  if (address) {
    return address;
  }

  const label = item.property_label?.trim();
  if (label) {
    return label;
  }

  const pagePath = item.page_path?.trim();
  if (pagePath) {
    return pagePath;
  }

  return `Imóvel ${item.property_id}`;
}

export function resolvePropertyAnalyticsDisplayName(item: IPropertyAnalyticsItem): string {
  return `${resolvePropertyAnalyticsLabel(item)} · #${item.property_id}`;
}

export function buildPropertyAnalyticsFilterOptions(
  items: IPropertyAnalyticsItem[]
): PropertyIdFilterOption[] {
  const optionsById = new Map<number, PropertyIdFilterOption>();

  items.forEach((item) => {
    if (!optionsById.has(item.property_id)) {
      optionsById.set(item.property_id, {
        propertyId: item.property_id,
        label: resolvePropertyAnalyticsDisplayName(item),
      });
    }
  });

  return Array.from(optionsById.values()).sort((first, second) =>
    first.label.localeCompare(second.label, "pt-BR")
  );
}
